'use client';

import { forwardRef, type ComponentPropsWithoutRef } from 'react';

/**
 * Thin wrapper around the native `<form>` element that defaults `noValidate`
 * to `true`.
 *
 * The `@apex-titan/ui` atoms (`Input`, `Textarea`, etc.) set the native HTML
 * `required` attribute when passed `required` (needed for `aria-required` and
 * the visual asterisk). Without `noValidate`, a raw `<form>` runs native
 * constraint validation and blocks the `submit` event before React Hook Form
 * + Zod ever run, so the Zod error would never render via the RHF path.
 * Defaulting `noValidate` here defers gating to Zod while keeping `required`
 * for its accessibility and visual affordances. Still overridable via props
 * for the rare form that wants native validation.
 */
export const Form = forwardRef<
  HTMLFormElement,
  ComponentPropsWithoutRef<'form'>
>(function Form({ noValidate = true, ...props }, ref) {
  return <form ref={ref} noValidate={noValidate} {...props} />;
});
